import { _js } from '@ifixit/utils/localize';
import { store } from 'Shared/react-initialize';
import * as HeaderActions from 'Shared/Header/actions';

const WorkbenchManager = {
   addItem: function (topicVariantid, wikiid, useIndicator, topicTitle) {
      topicTitle = topicTitle ? topicTitle : null;
      let request = new Request.API_2_0('user/workbench/add?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
         topicTitle: topicTitle,
         productcode: App.productcode,
         source: 'wiki',
      });

      request.done(response => {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Adding'),
            successMessage: _js('Added'),
         });
      }
   },

   removeItem: function (topicVariantid, wikiid, useIndicator) {
      let request = new Request.API_2_0('user/workbench/remove?langid=' + App.lang, {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      request.done(response => {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });

      if (useIndicator) {
         LoadingIndicator.withPromise(request, {
            pendingMessage: _js('Removing'),
            successMessage: _js('Removed'),
         });
      }
   },

   setActiveItem: function (dropdownId) {
      dropdownId = dropdownId.split('-');
      let wikiid = parseInt(dropdownId[0], 10);
      let topicVariantid = dropdownId[1];

      let request = new Request.API_2_0('user/workbench/set_active', {
         method: 'POST',
      }).send({
         wikiid: wikiid,
         topicVariantid: topicVariantid,
      });

      request.done(response => {
         store.dispatch(HeaderActions.updateWorkbench(response.topics));
      });
   },
};

export default WorkbenchManager;
